import React, { useState } from 'react';
import { connect } from 'react-redux';
import PopUp from '../HOC/PopUp';
import XCircleIcon from '../../images/x-circle.svg';

const Cancel = (props) => {
  const [showCancelPopup, setShowCancelPopup] = useState(false);

  const onCancelClickHandler = () => {
    document.getElementById('cancel-form').submit();
    setShowCancelPopup(false);
  };

  return (
    <div className={`${props?.merchantLogoSrc ? 'mercahnt-logo-enable' : ''} cancel-header container`}>
      <div
        style={{
          ...(props?.isCheckoutCancelButtonDisabled
            ? {
                cursor: 'not-allowed',
              }
            : {
                cursor: 'pointer',
              }),
        }}
      >
        <div
          className={`${
            props?.isCheckoutCancelButtonDisabled
              ? 'custom-cancel-btn-disabled'
              : ''
          }`}
          onClick={() => setShowCancelPopup(true)}
        >
          <span className='cancel-text'>Cancel</span>
          <img src={XCircleIcon} alt='cancel' />
        </div>
      </div>
      {showCancelPopup && (
        <PopUp
          onClose={() => setShowCancelPopup(false)}
          isContinueButtonToBeHide='true'
        >
          <>
            <div class='modal-body clearfix'>
              <h3>Cancel Payment?</h3>
              <p>This payment is still active.</p>
              <p>Please confirm if you want to cancel it?</p>
            </div>
            <form
              id='cancel-form'
              method='post'
              action={`${
                process.env.REACT_APP_PG_CONTROLLER
              }pinepg/v2/session/cancel?token=${encodeURIComponent(
                props?.token
              )}`}
            ></form>
            <div className='col-12 p-0'>
              <button
                className='btn btn-grey'
                onClick={() => setShowCancelPopup(false)}
              >
                No
              </button>
              <button className='btn btn-green' onClick={onCancelClickHandler}>
                Yes, Cancel
              </button>
            </div>
          </>
        </PopUp>
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    token: state.merchantPaymentDataFetchingReducer.token,
    isCheckoutCancelButtonDisabled:
      state.merchantPaymentDataFetchingReducer.isCheckoutCancelButtonDisabled,
  };
};

export default connect(mapStateToProps, {})(Cancel);
